import { PropsWithChildren } from 'react'
import { Route as RouterRoute } from 'react-router-dom'
import { Breadcrumb } from '../components/Breadcrumbs/Breadcrumbs'

type RouteProps = PropsWithChildren<{
  crumb?: boolean
  title?: string
  render?: (routeProps: any) => React.ReactNode
  [key: string]: any
}>

const Route = ({ crumb, title, render, children, ...rest }: RouteProps) => {
  if (crumb) {
    return (
      <RouterRoute
        {...rest}
        render={(routeProps) => (
          <>
            <Breadcrumb title={title} to={routeProps.match.url} />
            {render ? render(routeProps) : children}
          </>
        )}
      />
    )
  } else {
    return <RouterRoute render={render} children={children} {...rest} />
  }
}

export default Route
